import getSessionContext from 'src/utils/context/getSessionContext'
import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'ci.brokers' // ci.brokers table doesn't exist. brokers are subset of orgs. But there are controllers that handle ci.brokers requests

const state = {
  ...makeTableCommonState()
}

const getters = {
  ...makeTableCommonGetters({ remoteEntityName }),

  pageTitle: () => 'Brokers',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: -1,
      fetch: 0,
      update: -1,
      delete: -1,
      downloadList: -1,
      uploadList: -1
    }
  },

  controllerDefaultParams: (state, getters, rootState) => {
    return {
      fetch: { org_id: getSessionContext().org_id }
    }
  },

  columns: () => {
    return [
      { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenCreating: true, isNumeric: true },
      { name: 'name', label: 'Name', field: 'name', inlineEdit: true, align: 'left', required: true }
    ]
  }
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
